/**
 * Wheel and trackpad zoom gain, applied to every map by MapCanvas.
 *
 * These are not multipliers on zoom. Mapbox feeds them into a logistic curve clamped at 2x scale
 * per frame — `scale = 2 / (1 + exp(-|delta * rate|))` — so raising the rate mostly makes the curve
 * saturate sooner, which trades proportionality for reach rather than making zoom "faster".
 *
 * Provenance, because the repo had none: both values arrived in 096d07dce3 (2024-08-28, "Zooming
 * behavior", nine lines, no ticket, no measurement) and ZOOM_RATE is verbatim the example from
 * mapbox's own setZoomRate doc comment. They are 4x and 4.5x mapbox's defaults (1/100 and 1/450).
 * Kept as-is so the Workflows map keeps the feel it has shipped with, but moved here because they
 * lived on one store and so five of the six map surfaces silently ran mapbox's defaults instead.
 */
export const ZOOM_RATE = 1 / 25
export const WHEEL_ZOOM_RATE = 1 / 100
